export default {
	编号: 'シリアルナンバー：',
	标题: 'タイトル',
	操作: '操作する',
	订单编号: '注文番号',
	发布时间: 'リリース時間',
	发起时间: '打ち上げ時間',
	发送: '送信',
	附件: '付録',
	工单编号: 'チケット番号',
	工单不存在: '作業指示が存在しません',
	工单管理: '作業指示管理',
	工单类型: 'タイプ',
	工单详情: '作業指示の詳細',
	工单已关闭: 'チケットを閉じました',
	沟通记录: 'やりとり',
	关闭备注占位: '備考（任意）',
	关闭工单: 'チケットを閉じる',
	关联订单: '関連する注文',
	回复: '返事',
	回复内容: '返信内容',
	回复时间: '返信時間',
	加载中: '読み込み中',
	客服: 'カスタマーサポート',
	客户: 'お客様',
	聊天功能即将上线: 'チャット機能は近日公開予定',
	没有更多: 'これ以上ありません',
	内容: 'コンテンツ',
	请输入订单编号: '注文番号を入力してください',
	请输入工单标题: '作業指示書のタイトルを入力してください',
	请输入工单内容: '作業指示の内容を入力してください',
	请输入回复内容: '返信内容を入力してください',
	请填写内容或上传附件: '内容を入力するか、添付ファイルをアップロードしてください',
	请选择类型: 'チケットの種類を選択してください',
	请选择状态: 'ステータスを選択してください',
	确认关闭工单: 'このチケットを閉じますか？問題が発生した場合は、後で新しいチケットを送信できます。',
	售后工单必须关联订单: '販売後チケットには関連する注文を選択する必要があります',
	搜索: '検索',
	无关联: '関係ありません',
	无关联订单: '関連する注文はありません',
	详情: '詳細',
	新增工单: '新しい作業指示を追加する',
	修改: '改訂',
	修改工单: '作業指示を変更する',
	业务员: '担当者',
	暂无消息: 'メッセージはまだありません',
	重置: 'リセット',
	状态: '州',
}
